import { render } from "./TimeCounter.vue?vue&type=template&id=135557d9"
import script from "./TimeCounter.vue?vue&type=script&lang=js"
export * from "./TimeCounter.vue?vue&type=script&lang=js"

import "./TimeCounter.vue?vue&type=style&index=0&id=135557d9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__